import React from "react";
var ArrowLast = function ArrowLast(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M15.2 13.7 4.1 23.5l-.1.1c-.8.7-1.9.6-2.6-.2-.7-.8-.6-1.9.2-2.6l9.8-8.6c.1-.1.1-.3 0-.4L1.7 3.2C.9 2.5.9 1.4 1.5.7c.7-.8 1.8-.9 2.6-.2l11.2 9.8c.5.4.8 1.1.8 1.7-.1.6-.4 1.3-.9 1.7zM22.2 24c-1 0-1.8-.8-1.8-1.8V1.8c0-1 .8-1.8 1.8-1.8S24 .8 24 1.8v20.5c0 .9-.8 1.7-1.8 1.7z"
  }));
};
ArrowLast.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  xmlSpace: "preserve"
};
import createIconComponent from '../createIconComponent';
export const ArrowLastIcon = createIconComponent(ArrowLast, 'ArrowLast');